export default __webpack_public_path__ + "static/media/rainy-day.57b30e8f.jpg";